import * as Yup from 'yup'

const holidayValidator = Yup.object ({
  start_date: Yup
    .string ()
    .required ('Selecione uma data de início'),

  end_date: Yup
    .string ()
    .required ('Selecione uma data final')
    .test (
      'is-greater-or-equal',
      'A data final deve ser maior ou igual à data inicial.',
      function (value) {
        const { start_date } = this.parent
        if (!start_date || !value) return true
        return value >= start_date
      }
    ),

  start_time: Yup
    .object ()
    .nullable ()
    .required ('Selecione o horário inicial'),

  end_time: Yup
    .object ()
    .nullable ()
    .required ('Selecione o horário final')
})

export default holidayValidator
